import { useCallback, useEffect, useState } from "react"

import { Flex, Modal, Spin, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import SourceOrCampaignForm from "../../../../Components/Forms/SourceOrCampaignForm"
import Table from "../../../../Components/Table"
import { getDates } from "../../../../Utils/utils"
import MarketingActions from "../../reducer"
import { columns } from "../Table/columns"

const { Text } = Typography

const tableSettings = {
  scroll: {
    x: "100%",
    y: "calc(54px * 5)",
    scrollToFirstRowOnChange: true
  }
}

//block_type source or campaign
const SourceCampaignBlock = ({ block_type }) => {
  const [ordering, setOrdering] = useState(null)
  const [addModal, setAddModal] = useState(false)
  const dispatch = useDispatch()

  const { fetchingSource, source, fetchingCampaign, campaign, saveFetching, saveResult, filters } =
    useSelector((state) => state.marketing)
  const isMobile = useSelector((state) => state.nav.isMobile)

  const { results } = block_type === "source" ? source : campaign
  const loading = block_type === "source" ? fetchingSource : fetchingCampaign

  const handleCloseModal = () => {
    setAddModal(false)
  }

  const updateData = useCallback(
    (ordering, period_query) => {
      if (block_type === "source")
        dispatch(MarketingActions.getSourceRequest({ ordering, ...period_query }))
      if (block_type === "campaign")
        dispatch(MarketingActions.getCampaignRequest({ ordering, ...period_query }))
    },
    [ordering]
  )

  useEffect(() => {
    const period_query = getDates(filters.period)
    updateData(ordering, period_query)
  }, [ordering, filters?.period])

  useEffect(() => {
    if (["source_add", "campaign_add"]?.includes(saveResult?.type) && addModal) {
      handleCloseModal()
      updateData()
    }
  }, [saveResult])

  const handleChangeTable = useCallback((pagination, filters, sorter) => {
    let ordering = null
    if (sorter) {
      if (Array.isArray(sorter)) {
        ordering = sorter
          ?.map(({ field, order }) => (order === "ascend" ? field : `-${field}`))
          .join(",")
      } else {
        if (sorter.order) {
          ordering = sorter.order === "ascend" ? sorter.field : `-${sorter.field}`
        }
      }
    }
    setOrdering(ordering)
  }, [])

  const handleSubmitForm = (data) => {
    if (block_type === "source") dispatch(MarketingActions.createSourceRequest(data))
    if (block_type === "campaign") dispatch(MarketingActions.createCampaignRequest(data))
  }

  return (
    <Flex vertical gap={18}>
      <Flex align="center" justify="space-between">
        <Text style={{ fontWeight: 600, fontSize: 16 }}>{`All ${block_type}s`}</Text>
        <ButtonComponent onClick={() => setAddModal(true)}>{`Add ${block_type}`}</ButtonComponent>
      </Flex>

      <Table
        columns={columns}
        loading={loading}
        dataSource={results}
        scroll={tableSettings.scroll}
        onChange={handleChangeTable}
        showSizeChanger={false}
        withOutPagination={true}
      />

      <Modal
        open={addModal}
        centered={!isMobile}
        width={442}
        title={`Add ${block_type}`}
        footer={null}
        closable="true"
        onCancel={handleCloseModal}
        destroyOnClose
        classNames={{ content: "clear-bg" }}
      >
        <Spin size="large" spinning={saveFetching}>
          <SourceOrCampaignForm onSubmit={handleSubmitForm} onClose={handleCloseModal} />
        </Spin>
      </Modal>
    </Flex>
  )
}

export default SourceCampaignBlock
